import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_download.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-390a3773")

_pushScopeId("data-v-390a3773")
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-base font-medium text-black-lp-100" }
const _hoisted_3 = { class: "text-10px text-black-lp-100" }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = { class: "font-semibold flex items-center gap-1" }
const _hoisted_6 = { class: "text-xl text-red-lp-2000" }
const _hoisted_7 = { class: "text-base text-black-lp-300" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "download-icon"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    id: "lp-bagging-list-dispute-summary-*",
    class: "dispute-summary flex justify-between items-center py-3 px-5 border border-red-lp-2800 rounded-2xl mt-6 mb-5",
    style: {
      backgroundImage: `url(${require('@/app/ui/assets/svg/bg-dispute-summary.svg')})`
    }
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('bagging.disputeSummaryTitle')), 1),
      _createVNode("p", _hoisted_3, " Data " + _toDisplayString(_ctx.formatDate(_ctx.baggingDisputeSummaryData.startDate)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.baggingDisputeSummaryData.endDate)), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("p", _hoisted_5, [
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.baggingDisputeSummaryData.totalBaggingDispute) + "/" + _toDisplayString(_ctx.baggingDisputeSummaryData.totalBaggingData), 1),
        _createVNode("span", _hoisted_7, "(" + _toDisplayString(_ctx.baggingDisputeSummaryData.totalPercentage) + "%) BAG", 1)
      ]),
      _createVNode("div", null, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadExcel && _ctx.downloadExcel(...args))),
          onEnter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadExcel && _ctx.downloadExcel(...args))),
          id: "lp-bagging-list-dispute-summary-download-btn"
        }, [
          _hoisted_8
        ], 32)
      ])
    ])
  ], 4))
})